'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionDashboard = function ActionDashboard(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
  );
};
ActionDashboard = (0, _pure2.default)(ActionDashboard);
ActionDashboard.displayName = 'ActionDashboard';

exports.default = ActionDashboard;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/dashboard.js
 ** module id = 998
 ** module chunks = 0
 **/